(function () {
	const collectionTabs = (root) => {
		root.querySelectorAll(".collection-tabs").forEach((tabSection) => {
			if (tabSection.dataset.tabsBound === "true") return;
			tabSection.dataset.tabsBound = "true";
			const tabs = tabSection.querySelectorAll("[data-tab-target]");
			const tabContents = tabSection.querySelectorAll("[data-tab-content]");
			tabs.forEach((tab) => {
				tab.addEventListener("click", () => {
					const selector = tab.dataset.tabTarget;
					const target = selector ? tabSection.querySelector(selector) : null;
					if (!target) return;
					tabContents.forEach((tabContent) => {
						tabContent.classList.remove("active");
					});
					tabs.forEach((tab) => {
						tab.classList.remove("active");
					});
					tab.classList.add("active");
					target.classList.add("active");
				});
			});
		});
	};
	/* Fix: if active tab has 0 cards (PDP vendor filter), move active to first tab with cards */
	const fixEmptyActiveTab = (root) => {
		root.querySelectorAll(".collection-tabs").forEach((s) => {
			const active = s.querySelector("[data-tab-content].active");
			if (!active || active.querySelectorAll(".collection-tabs_card").length > 0) return;
			active.classList.remove("active");
			const items = s.querySelectorAll("[data-tab-content]");
			for (let i = 0; i < items.length; i++) {
				if (items[i].querySelectorAll(".collection-tabs_card").length > 0) {
					items[i].classList.add("active");
					break;
				}
			}
		});
	};
	document.addEventListener("DOMContentLoaded", function () {
		collectionTabs(document);
		fixEmptyActiveTab(document);
		document.addEventListener("shopify:section:load", function (event) {
			/* only (re)bind the freshly loaded section, not the whole document */
			collectionTabs(event.target);
			fixEmptyActiveTab(event.target);
		});
	});
})();
